import React from 'react';
import PropTypes from 'prop-types';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { intlShape } from '../../../components/prop-types';

const i18n = defineMessages({
  visitUrl: { id: 'attrs.visitUrl', defaultMessage: 'Visit URL' },
  copy: { id: 'attrs.copy', defaultMessage: 'Copy' },
});

const SuperLinkUrlComponent = ({ superLink, intl: { formatMessage } }) => (
  <div>
    <h5 className="super-link-url-text">
      <FormattedMessage id="superLink.publicUrl" defaultMessage="SuperLink Public URL">
        {text => (
          <span>
            {`${text} :`}
          </span>
        )}
      </FormattedMessage>
    </h5>
    <div className="p-inputgroup">
      <Button
        icon="pi pi-external-link"
        className="p-button-secondary"
        onClick={() => {
          window.open(superLink.publicURL, '_blank');
        }}
        tooltip={formatMessage(i18n.visitUrl)}
        tooltipOptions={{ position: 'top', fontSize: '10px' }}
      />
      <InputText
        style={{ width: '100%' }}
        placeholder="super-link public url"
        defaultValue={superLink.publicURL}
        readOnly
      />
      <CopyToClipboard text={superLink.publicURL} options={{ format: 'text/plain' }}>
        <Button
          icon="pi pi-clone"
          className="p-button-secondary"
          tooltip={formatMessage(i18n.copy)}
          tooltipOptions={{ position: 'top' }}
        />
      </CopyToClipboard>
    </div>
  </div>
);

SuperLinkUrlComponent.propTypes = {
  intl: intlShape.isRequired,
  superLink: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectIntl(SuperLinkUrlComponent);
